import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type ImputationSimulation from '../../interfaces/simulation/imputationSimulation';
import type Service from '../../interfaces/simulation/service';

const getRAR = (identifiant: number) =>
	request.get<any, TemplateRequestGet<ImputationSimulation>>(
		`/api/finances/simulation/imputationSimulation?identifiantSimulation=${identifiant}&rar=not(0)&perPage=1`,
	);

export const getServices = (
	identifiantImputationSimulation: number,
): Promise<Service[]> =>
	request.get(
		`/api/finances/simulation/imputationSimulation/services?identifiantImputationSimulation=${identifiantImputationSimulation}`,
	);

// Services rattaches a une ligne budgetaire identifiee par ses parametres
// d'imputation (cf getImputationParams), y compris sans montant (donc sans
// identifiantImputationSimulation connu du front)
export const getServicesByImputation = (
	params: URLSearchParams,
): Promise<Service[]> =>
	request.get(
		`/api/finances/simulation/imputationSimulation/services?${params.toString()}`,
	);

export default getRAR;
